import { useState } from "react";
import { Check, ChevronsUpDown, Search } from "lucide-react";
import { Button } from "./ui/button";
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from "./ui/command";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import { useMenu, formatINR } from "../lib/MenuContext";
import { cn } from "../lib/utils";

export default function MenuCombobox({ value, onChange, testid = "menu-search-dropdown" }) {
  const [open, setOpen] = useState(false);
  const { menu, loading } = useMenu();
  const selected = menu.find((m) => m.id === value);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          role="combobox"
          aria-expanded={open}
          data-testid={testid}
          className="w-full justify-between bg-white border-[#E6E2D8] h-12 text-base text-[#1A1918] font-medium hover:bg-white hover:border-[#C84C31]"
        >
          <span className="flex items-center gap-2 truncate">
            <Search size={16} className="text-[#5C5854] shrink-0" />
            {selected ? selected.name : loading ? "Loading menu..." : "Search menu items..."}
          </span>
          <ChevronsUpDown size={16} className="opacity-50 shrink-0" />
        </Button>
      </PopoverTrigger>
      <PopoverContent
        className="p-0 w-[--radix-popover-trigger-width] bg-[#FFFCF5] border-[#E6E2D8]"
        align="start"
        onOpenAutoFocus={(e) => e.preventDefault()}
      >
        <Command className="bg-transparent" shouldFilter={true}>
          <CommandInput
            placeholder="Type to search..."
            data-testid="menu-combobox-input"
            className="h-11"
            autoFocus={false}
          />
          <CommandList>
            <CommandEmpty>No items found.</CommandEmpty>
            <CommandGroup>
              {menu.map((m) => (
                <CommandItem
                  key={m.id}
                  value={m.name}
                  onSelect={() => {
                    onChange(m.id);
                    setOpen(false);
                  }}
                  className="cursor-pointer aria-selected:bg-[#F5F2EB] aria-selected:text-[#1A1918]"
                  data-testid={`menu-item-${m.id}`}
                >
                  <Check
                    className={cn(
                      "mr-2 h-4 w-4 text-[#C84C31]",
                      value === m.id ? "opacity-100" : "opacity-0"
                    )}
                  />
                  <span className="flex-1">{m.name}</span>
                  <span className="text-sm font-semibold text-[#5C5854]">
                    {formatINR(m.price)}
                  </span>
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
